// extracted by mini-css-extract-plugin
export default {"chip":"ActivityTypeChip_chip__MdT1X","chipActive":"ActivityTypeChip_chipActive__7SpI5","dot":"ActivityTypeChip_dot__Jzue1"};